import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons/faBarcodeRead';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faClipboardCheck } from '@fortawesome/pro-regular-svg-icons/faClipboardCheck';
import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck';
import { ROUTE_PATHS } from 'routes/routes-paths';
import agentMigration from './assets/agent-migration-agents.png';
import agentNitroAnalysts from './assets/agent-nitro-analysts.png';
import agentRm from './assets/agent-rm-agents.png';
import agentWorkforce from './assets/agent-workforce-agents.png';
export const ROUTE_BASE = `/${ROUTE_PATHS.NITRO_CLAW}`;
export const RESERVED_SEGMENTS = new Set([
    'for-review',
    'notifications',
    'projects',
    'meetings',
    'tasks',
    'agents'
]);
const AGENT_BUILDER_BASE = `/${ROUTE_PATHS.AGENT_BUILDER}`;
export const AI_ANALYTICS_ROUTE_BASE = `/${ROUTE_PATHS.AI_ANALYTICS}`;
const RM_AGENT_PATH = '/agents/rm';
const RM_COPILOT_PATH = `/${ROUTE_PATHS.RESOURCE_MANAGEMENT}/${ROUTE_PATHS.RM_COPILOT}`;
const pathMatchesPrefix = (pathname, prefix)=>pathname === prefix || pathname.startsWith(`${prefix}/`);
export const AGENT_ITEMS = [
    {
        id: 'nitro-analysts',
        labelKey: 'nitro_claw.sidebar.agents.nitro_analysts',
        defaultMessage: 'Nitro Analysts',
        iconSrc: agentNitroAnalysts,
        path: AI_ANALYTICS_ROUTE_BASE,
        match: (pathname)=>pathMatchesPrefix(pathname, AI_ANALYTICS_ROUTE_BASE)
    },
    {
        id: 'migration',
        labelKey: 'nitro_claw.sidebar.agents.migration',
        defaultMessage: 'Migration Agents',
        iconSrc: agentMigration,
        path: `${AGENT_BUILDER_BASE}/migration-agents`,
        match: (pathname)=>pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/migration-agents`)
    },
    {
        id: 'workforce',
        labelKey: 'nitro_claw.sidebar.agents.workforce',
        defaultMessage: 'Workforce Agents',
        iconSrc: agentWorkforce,
        path: `${AGENT_BUILDER_BASE}/workforce-agents`,
        match: (pathname)=>pathMatchesPrefix(pathname, `${AGENT_BUILDER_BASE}/workforce-agents`)
    },
    {
        id: 'rm',
        labelKey: 'nitro_claw.sidebar.agents.rm',
        defaultMessage: 'RM Agents',
        iconSrc: agentRm,
        path: RM_AGENT_PATH,
        match: (pathname)=>pathMatchesPrefix(pathname, RM_AGENT_PATH) || pathMatchesPrefix(pathname, RM_COPILOT_PATH)
    }
];
export const pathEndsWith = (pathname, segment)=>pathname === `${ROUTE_BASE}/${segment}` || pathname.startsWith(`${ROUTE_BASE}/${segment}/`);
export const buildPrimaryNavItems = (pending)=>[
        {
            id: 'for-review',
            labelKey: 'nitro_claw.sidebar.for_review',
            defaultMessage: 'For Review',
            icon: faBarcodeRead,
            path: `${ROUTE_BASE}/for-review`,
            match: (path)=>pathEndsWith(path, 'for-review')
        },
        {
            id: 'notifications',
            labelKey: 'nitro_claw.sidebar.notifications',
            defaultMessage: 'Notifications',
            icon: faBell,
            path: `${ROUTE_BASE}/notifications`,
            match: (path)=>pathEndsWith(path, 'notifications'),
            badge: pending > 0 ? pending : undefined
        }
    ];
export const RESOURCE_NAV_ITEMS = [
    {
        id: 'projects',
        labelKey: 'nitro_claw.sidebar.resources.projects',
        defaultMessage: 'Projects',
        icon: faClipboardCheck,
        path: `${ROUTE_BASE}/projects`,
        match: (path)=>pathEndsWith(path, 'projects')
    },
    {
        id: 'meetings',
        labelKey: 'nitro_claw.sidebar.resources.meetings',
        defaultMessage: 'Meetings',
        icon: faCalendar,
        path: `${ROUTE_BASE}/meetings`,
        match: (path)=>pathEndsWith(path, 'meetings')
    },
    {
        id: 'tasks',
        labelKey: 'nitro_claw.sidebar.resources.tasks',
        defaultMessage: 'Tasks',
        icon: faListCheck,
        path: `${ROUTE_BASE}/tasks`,
        match: (path)=>pathEndsWith(path, 'tasks')
    }
];
